import api from "../../../apiClient";

// Chemical tracking + ledger-derived inventory (backend: inventory_app/views_chemicals.py).
export const getOnHand = () => api.get("/inventory/on-hand/").then((r) => r.data);
export const getProductLedger = (id) => api.get(`/inventory/products/${id}/ledger/`).then((r) => r.data);
// Unit cost — written only through this audited endpoint (who set it, when, from what).
export const getUnitCost = (id) => api.get(`/inventory/products/${id}/unit-cost/`).then((r) => r.data);
export const setUnitCost = (id, payload) => api.post(`/inventory/products/${id}/unit-cost/`, payload).then((r) => r.data);
// CSV of product, cost, unit. Preview first; commit applies every row, or none if any row has an error.
export const importUnitCosts = (csvText, commit) =>
  api.post(`/inventory/products/unit-costs/import/${commit ? "?commit=1" : ""}`, { csv: csvText }).then((r) => r.data);
export const postMovement = (payload) => api.post("/inventory/movements/", payload).then((r) => r.data);
export const createLocation = (payload) => api.post("/inventory/locations/", payload).then((r) => r.data);
// Locations with their linked fleet vehicle (a truck location ↔ one vehicle; the tech's
// "log material" deducts from the truck linked to the vehicle assigned to them).
export const listLocations = () => api.get("/inventory/locations/").then((r) => r.data?.results || r.data || []);
export const updateLocation = (id, payload) => api.patch(`/inventory/locations/${id}/`, payload).then((r) => r.data);
export const listVehicles = () => api.get("/fleet/vehicles/").then((r) => r.data?.results || r.data || []);
export const listApplications = (params) => api.get("/inventory/applications/", { params }).then((r) => r.data);
export const listFlags = (params) => api.get("/inventory/application-flags/", { params }).then((r) => r.data);
export const decideFlag = (id, action) =>
  api.post(`/inventory/application-flags/${id}/`, { action }).then((r) => r.data);
export const listLabelRates = (productId) =>
  api.get(`/inventory/products/${productId}/label-rates/`).then((r) => r.data);
export const addLabelRate = (productId, payload) =>
  api.post(`/inventory/products/${productId}/label-rates/`, payload).then((r) => r.data);
export const decideLabelRate = (rateId, action) =>
  api.post(`/inventory/label-rates/${rateId}/decision/`, { action }).then((r) => r.data);

export const errorText = (err, fallback) =>
  err?.response?.data?.detail || (err?.response?.status === 403 ? "You don't have permission for this." : fallback);

export const qty = (v, unit) => {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  const s = Math.abs(n) >= 100 ? n.toFixed(0) : Math.abs(n) >= 10 ? n.toFixed(1) : n.toFixed(2);
  return `${s.replace(/\.?0+$/, "") || "0"}${unit ? ` ${unit}` : ""}`;
};

export const CONVERSION_WORDS = {
  fr_concentrate: "Concentrate logged in FieldRoutes",
  direct: "Logged in the product's unit",
  mix_ratio: "Converted with the record's mix ratio",
  dilution_pct: "Converted with the record's dilution %",
  unconverted: "Can't convert without guessing — not deducted",
  no_quantity: "No amount logged — not deducted",
  no_product: "Product not in the catalog — not deducted",
};

export const FLAG_WORDS = {
  over_label_rate: "Over the label's maximum rate",
  over_annual_max: "Over the label's yearly maximum",
  peer_high: "More than 2× the usual rate for this service",
  peer_low: "Less than half the usual rate for this service",
  size_unknown: "Property size unknown",
  unconverted: "Amount can't be converted",
  no_quantity: "No amount logged",
  odd_unit: "Missing or unusual unit",
  not_in_catalog: "Product not in the catalog",
};

// Tenant-wide ledger (lane INV leg 5): every movement as a row — who, when, product, qty,
// from → to, reason, visit, receipt/photo. Filters: product, location, actor, reason, type,
// appointment, since, until, q, page, page_size.
export const getLedger = (params) => api.get("/inventory/ledger/", { params }).then((r) => r.data);

// Deliveries (typed on the phone or the web) — the same ReceiptImport rows the scan rail makes;
// status "draft" is a typed delivery saved to finish later.
export const listDeliveries = (params) => api.get("/inventory/deliveries/", { params }).then((r) => r.data);
export const postDelivery = (id, payload) => api.post(`/inventory/deliveries/${id}/post/`, payload || {}).then((r) => r.data);
